const guides = {
  indexTitle: 'Gidsen voor horeca-ops',
  indexIntro:
    'Korte, praktische gidsen voor managers en eigenaren. Print ze desnoods eerst. Draai dezelfde routines daarna in GastroBuddy.',
  pickLabel: 'Kies een gids',
  cta: 'Start mijn gratis maand',
  ctaHint: 'Zet dit om in live takenlijsten voor je team',
  seeVerticals: 'GastroBuddy per type zaak →',
  seeChecklist: 'Gratis open/sluit-checklist →',
  otherGuides: 'Meer gidsen',
  readTime: 'Ongeveer {minutes} min lezen',
  'open-close': {
    metaTitle: 'Open/sluit-checklist: gids voor restaurants en bars',
    metaDescription:
      'Zo maak je open- en sluitroutines die je team echt volgt. En die je daarna in GastroBuddy draait.',
    title: 'Openen en sluiten zonder ringband',
    intro:
      'Goede open- en sluitlijsten voorkomen verrassingen bij service en bij afsluiten. Houd ze kort, met een duidelijke eigenaar, en zichtbaar.',
    minutes: '4',
    sections: {
      s1Title: '1. Splits openen en sluiten',
      s1Body:
        'Eén reuzenlijst wordt overgeslagen. Scheid openen, tussendoor en sluiten. Dan ziet iedereen alleen de stappen die ertoe doen.',
      s2Title: '2. Benoem de eigenaar',
      s2Body:
        'Elk item moet duidelijk maken wie het doet: opener, closer, bar of keuken. Vage lijsten maken gaten.',
      s3Title: '3. Houd het kort voor de vloer',
      s3Body: 'Duur het lezen langer dan het doen, snijd bij. Alleen het kritieke pad. Geen roman.',
      s4Title: '4. Maak voortgang zichtbaar',
      s4Body:
        'Managers moeten zien wat klaar is zonder de service te storen. Daar wint een gedeelde app van papier.',
      s5Title: '5. Kijk er wekelijks naar',
      s5Body:
        'Schrap stappen die nooit ertoe doen. Voeg toe wat vorige week misging. Lijsten groeien mee met de zaak.',
    },
    tip: 'Begin met onze gratis printbare open/sluit-checklist. Zet dezelfde structuur daarna in GastroBuddy.',
  },
  'staff-onboarding': {
    metaTitle: 'Personeel inwerken met stappenplannen in de horeca',
    metaDescription:
      'Praktische aanpak om nieuw vloerpersoneel in te werken met checklists. Niet alleen stille kennis.',
    title: 'Inwerken met plannen, niet alleen meelopen',
    intro: 'Meelopen blijft belangrijk. Zonder pad hangt kwaliteit af van wie wie opleidde.',
    minutes: '5',
    sections: {
      s1Title: '1. Alleen de essentials op dag één',
      s1Body: 'Veiligheid, gastflow, kassa en de top vijf stationstaken. De rest kan week twee.',
      s2Title: '2. Lijsten per rol',
      s2Body:
        'Bediening, bar, keuken en closer verschillen. Eén mega-lijst overweldigt nieuwkomers.',
      s3Title: '3. Toon afronding',
      s3Body:
        'Trainers en managers zien wat geoefend is. Zonder de hele dienst eroverheen te hangen.',
      s4Title: '4. Herhaal tot het saai is',
      s4Body:
        'Consistentie wint van slimheid. Dezelfde open- en sluitlijst bouwt sneller spiergeheugen.',
      s5Title: '5. Draag over aan het team',
      s5Body: 'Als de nieuweling de lijst zonder buddy afrondt, is zelfstandigheid dichterbij.',
    },
    tip: 'GastroBuddy is gemaakt voor stapsgewijze plannen op telefoon of tablet.',
  },
  'haccp-checks': {
    metaTitle: 'HACCP-achtige checks op de vloer — praktische gids',
    metaDescription:
      'Zo houd je voedselveiligheid-checks kort, op tijd, en echt afgerond tijdens service.',
    title: 'HACCP-achtige checks die gedaan worden',
    intro: 'Voedselveiligheid faalt in ringbanden. Zet kritieke checks waar het team al werkt.',
    minutes: '5',
    sections: {
      s1Title: '1. Eerst de kritieke controles',
      s1Body:
        'Temperaturen, koeling, allergenen, schoonmaak van risicovlakken. Niet elk “leuk om te hebben”.',
      s2Title: '2. Koppel aan momenten',
      s2Body:
        'Hang checks aan openen, midden in de dienst en sluiten. Momenten waarop de flow al even stilstaat.',
      s3Title: '3. Loggen zonder theater',
      s3Body:
        'Registratie moet seconden kosten. Wordt het formulier gevreesd, dan wordt het overgeslagen.',
      s4Title: '4. Escaleer uitzonderingen',
      s4Body: 'Een mislukte temperatuurcheck vraagt een volgende stap. Niet alleen een lege regel.',
      s5Title: '5. Bewijs toegankelijk houden',
      s5Body:
        'Managers en audits hebben historie nodig. Digitale lijsten winnen van zoekgeraakte pagina’s.',
    },
    tip: 'Gebruik GastroBuddy-takenlijsten voor terugkerende checks. Stem items af op jouw plan en juridisch advies.',
  },
  'cash-closing': {
    metaTitle: 'Kasafsluiting-checklist voor horecateams',
    metaDescription:
      'Rustige dagafsluiting: wisselgeld, fooien, pin-totalen en overdracht. Zonder gejakker om middernacht.',
    title: 'Kasafsluiting zonder gejakker',
    intro:
      'Dagafsluitingen gaan mis als kas in één schrift zit en taken elders. Maak er één routine van.',
    minutes: '4',
    sections: {
      s1Title: '1. Standaardiseer de volgorde',
      s1Body: 'Tellen, fooien, pin-afstemming, verschillen, kluis. Elke nacht dezelfde volgorde.',
      s2Title: '2. Twee personen waar nodig',
      s2Body:
        'Bepaal bij risicostappen wanneer een tweede persoon meekijkt. Duidelijkheid wint van improvisatie.',
      s3Title: '3. Leg verschillen meteen vast',
      s3Body: 'Noteer afwijkingen dezelfde nacht met een korte reden. Ochtendonderzoek is duur.',
      s4Title: '4. Koppel aan floorsluiting',
      s4Body: 'Kas is een hoofdstuk van sluiten. Geen apart ritueel nadat iedereen weg is.',
      s5Title: '5. Bewaar historie',
      s5Body: 'Eigenaren willen trends over dagen. Verspreid papier verbergt patronen.',
    },
    tip: 'GastroBuddy heeft kasregistratie en dagafsluitingen in hetzelfde account als je vloerlijsten.',
  },
  'mise-en-place': {
    metaTitle: 'Mise en place-lijsten voor keuken en bar',
    metaDescription: 'Zo structureer je MEP- en preplijsten zodat productie voorloopt op service.',
    title: 'Mise en place die voorloopt op service',
    intro:
      'Mise en place faalt als het stille kennis is. Schrijf herbruikbare prepplannen gekoppeld aan recepten en stations.',
    minutes: '4',
    sections: {
      s1Title: '1. Batches per station',
      s1Body: 'Groepeer prep per station of event. Niet als willekeurige boodschappenlijst.',
      s2Title: '2. Koppel prep aan recepten',
      s2Body: 'Als specs wijzigen, moet prep meeveranderen. Niet op een aparte sticky note leven.',
      s3Title: '3. Par levels in gewone taal',
      s3Body: '“Twee GN’s ui brunoise” wint van vaag “genoeg voor vrijdag”.',
      s4Title: '4. Sluit de lus na service',
      s4Body: 'Wat was op? Wat was te veel? Voed dat morgen weer in.',
      s5Title: '5. Deel keuken en bar',
      s5Body: 'Bargarnish en keuken-MEP delen vaak dezelfde koelkast. Eén systeem helpt.',
    },
    tip: 'GastroBuddy ondersteunt recepten en mise en place met keuken- en barcontext.',
  },
  'multi-location': {
    metaTitle: 'Multi-locatie horeca-ops — standaarden gelijk houden',
    metaDescription: 'Zo houden eigenaren met meerdere zaken open/sluit en kwaliteit consistent.',
    title: 'Multi-locatie zonder de standaard te verliezen',
    intro:
      'Twee zaken betekent twee culturen, tenzij routines expliciet zijn. Gedeelde structuur, lokale details.',
    minutes: '5',
    sections: {
      s1Title: '1. Eén kernlijst, lokale varianten',
      s1Body:
        'Merkkritieke stappen gelijk. Vestiging-specifieke toevoegingen voor layout of concept.',
      s2Title: '2. Vergelijk afronding, geen gevoel',
      s2Body: 'Managers moeten zien welke locatie open/sluit afrondt. Niet “het voelde prima”.',
      s3Title: '3. Scheid locaties schoon',
      s3Body: 'Personeel en modules horen bij de juiste plek, zodat voortgang niet mengt.',
      s4Title: '4. Owner-view in de browser',
      s4Body: 'Je staat niet op elke vloer. Een webdashboard telt even zwaar als de apps.',
      s5Title: '5. Rol langzaam uit',
      s5Body:
        'Pilot één locatie. Nodig daarna het volgende team uit. Alles tegelijk creëert weerstand.',
    },
    tip: 'GastroBuddy is gemaakt voor locaties, modules en een webdashboard naast mobiele apps.',
  },
} as const;

export default guides;



// WEBPACK FOOTER //
// ./src/i18n/messages/segments/guides.nl.ts